import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import PageSection from '../PageSection/PageSection';
import SectionTitle from '../SectionTitle/SectionTitle';
import ImageItem from './ImageItem/ImageItem';

import styles from './ImageBanner.scss';

const propTypes = {
    label: PropTypes.string.isRequired,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    className: PropTypes.string,
    imageClassName: PropTypes.string,
    layoutClassName: PropTypes.string,
    imageList: PropTypes.arrayOf(PropTypes.shape({
        src: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
    })).isRequired,
};

const defaultProps = {
    title: '',
    subtitle: '',
    className: '',
    imageClassName: '',
    layoutClassName: '',
};

function ImageBanner(props) {
    const {
        title,
        subtitle,
        label,
        imageList,
        className,
        imageClassName,
        layoutClassName,
    } = props;

    if (!imageList.length) {
        return null;
    }

    return (
        <PageSection
            aria-labelledby={label}
            className={className}
            layoutClassName={`${layoutClassName} ${styles.bannerLayout}`}
        >
            {!!title && (
                <SectionTitle
                    className={styles.title}
                    id={label}
                >
                    {title}
                </SectionTitle>
            )}
            {!!subtitle && (
                <span className={styles.subtitle}>
                    {subtitle}
                </span>
            )}
            <div
                className={classNames(
                    styles.images,
                    { [styles.withTitle]: !!title || !!subtitle },
                )}
            >
                {imageList.map((imageObj) => (
                    <ImageItem
                        {...imageObj}
                        imageClassName={imageClassName}
                        key={imageObj.src}
                    />
                ))}
            </div>
        </PageSection>
    );
}

ImageBanner.propTypes = propTypes;
ImageBanner.defaultProps = defaultProps;

export default ImageBanner;
